var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1530_8848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6897 1.87191C16.5919 1.51015 16.4009 1.18034 16.1359 0.91533C15.8709 0.650319 15.5411 0.459352 15.1793 0.361444C13.8549 0.000244141 8.52468 0.000244141 8.52468 0.000244141C8.52468 0.000244141 3.19415 0.0111774 1.86975 0.372377C1.50798 0.470291 1.17818 0.661268 0.913175 0.926291C0.648176 1.19131 0.457228 1.52114 0.359346 1.88291C-0.0412539 4.23611 -0.196654 7.82185 0.370346 10.0809C0.468238 10.4427 0.65919 10.7725 0.924189 11.0375C1.18919 11.3025 1.51899 11.4935 1.88075 11.5914C3.20515 11.9526 8.53555 11.9526 8.53555 11.9526C8.53555 11.9526 13.8659 11.9526 15.1902 11.5914C15.552 11.4935 15.8818 11.3025 16.1468 11.0375C16.4118 10.7725 16.6028 10.4427 16.7007 10.0809C17.1232 7.72438 17.2534 4.14084 16.6897 1.87191Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 8.53671L11.25 5.97551L6.82812 3.41431V8.53671Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1530_8848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0667,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.e78281b9f371dac033cc0d1f09faad66.svg";
export { ForwardRef as ReactComponent };